"use client";

import "./WebAppTestimonialSection.scss";
import user from "@/assets/images/testimonial/user.png";
import employee from "@/assets/images/testimonial/employee.png";
import client from "@/assets/images/testimonial/client.png";
import ClientTestimonialsSection from "@/components/ClientTestimonialsSection/ClientTestimonialsSection";

const WebAppTestimonialSection = () => {
  const MeattestimonialsData = [
    {
      name: "Ajith Kumar",
      label: "Modern Form Owner",
      description:
        "GOATAPP gave us better visibility into our farm operations and helped improve daily management efficiency.",
      image: client,
    },
    {
      name: "Vigneshwaran S",
      label: "Livestock Entrepreneur",
      description:
        "Managing large herd operations became much more organized after switching to GOATAPP.",
      image: employee,
    },
    {
      name: "Muthu Selvan",
      label: "Dairy & Goat Farm Operator",
      description:
        "We used to miss health checkups often. GOATAPP reminders helped us maintain a healthier herd.",
      image: user,
    },
    {
      name: "Dinesh Babu",
      label: "Goat Farmer",
      description:
        "Expense tracking became very clear after using GOATAPP. We finally understand where our farm costs are going.",
      image: client,
    },
    {
      name: "PORTEA",
      label: "Modern Form Owner",
      description:
        "Partnering with GSUS Star Software Solutions for our SAP implementation has been a game-changer. We've achieved unparalleled business control, streamlined our resources, and unlocked innovative solutions.",
      image: employee,
    },
  ];
  return (
    <>
      {" "}
      <ClientTestimonialsSection
        title="Trusted by Meat"
        highlightTitle="Shop Owners"
        description="Trusted by growning meat brands and local butchers shops, the platform improves operational speed and keeps every department connected in real-time."
        testimonialsData={MeattestimonialsData}
         background="bg-white"
      />
    </>
  );
};

export default WebAppTestimonialSection;
